import client, { apiEnv } from '../client';

export const getAllCertificationLightHouse = (body, token) => client.post(token)(
  apiEnv[apiEnv.env].url(
    apiEnv.LAST_PATH.CERTIFICATION,
    apiEnv.APIS.GET_ALL_CERTIFICATION_LIGHT_HOUSE,
  ),
  body,
);
export const getAllModelCar = (token) => client.post(token)(
  apiEnv[apiEnv.env].url(
    apiEnv.LAST_PATH.CONFIG_SYSTEM,
    apiEnv.APIS.GET_ALL_MODEL_CAR,
  ),
  {},
);
export const getAllColorExtCar = (token) => client.get(token)(
  apiEnv[apiEnv.env].url(
    apiEnv.LAST_PATH.CERTIFICATION,
    apiEnv.APIS.GET_ALL_COLOR_EXT_CAR,
  ),
  {},
);
export const getAllColorIntCar = (token) => client.get(token)(
  apiEnv[apiEnv.env].url(
    apiEnv.LAST_PATH.CERTIFICATION,
    apiEnv.APIS.GET_ALL_COLOR_INT_CAR,
  ),
  {},
);
